import React from "react";
import { graphql, Link } from "gatsby";
import { Header, Divider, Button, Icon } from "semantic-ui-react";

import BlockHeader from "components/BlockHeader";
import { PostCardList } from "components/PostCard";
import MainLayout from "../components/Layout/Layout";
import flattenNodes from "utils/flattenNodes";
import SavedArticlesContextProvider from "contexts/SavedArticlesContext";
import SEO from "components/seo/seo";

interface indexProps {
  readonly data: GatsbyTypes.homepageLatestQuery;
}

export const index: React.FC<indexProps> = ({ data }) => {
  const articles = flattenNodes(data.articles.edges);
  const courses = flattenNodes(data.courses.edges);

  return (
    <SavedArticlesContextProvider>
      <SEO
        title="Latest"
        description="A quick look at our latest tutorials and courses"
      />
      <MainLayout activePage="home">
        <Header as="h1" textAlign="center">
          Latest
        </Header>
        <div>
          <BlockHeader as={Link} to={"/articles"}>
            Articles and Tutorials
          </BlockHeader>

          <PostCardList data={articles} />

          <Button
            as={Link}
            to="/articles"
            size="large"
            icon
            labelPosition="right"
          >
            View More Articles
            <Icon name="arrow right" />
          </Button>
        </div>

        <Divider />

        <div>
          <BlockHeader as={Link} to={"/courses"}>
            Courses
          </BlockHeader>
          {process.env.NODE_ENV !== "development" ? (
            <p>Coming Soon!</p>
          ) : (
            <>
              <PostCardList data={courses} />

              <Button
                as={Link}
                to="/courses"
                size="large"
                icon
                labelPosition="right"
              >
                View More Courses
                <Icon name="arrow right" />
              </Button>
            </>
          )}
        </div>
      </MainLayout>
    </SavedArticlesContextProvider>
  );
};

export const pageQuery = graphql`
  query homepageLatest {
    articles: allMdx(
      filter: {
        frontmatter: { draft: { ne: true } }
        fileAbsolutePath: { glob: "**/articles/**" }
      }
      sort: { fields: [frontmatter___date], order: DESC }
      limit: 4
    ) {
      edges {
        node {
          id
          excerpt
          timeToRead
          frontmatter {
            title
            description
            tags
            subscriberOnly
            date
            source
            featuredImage {
              childImageSharp {
                fluid(maxWidth: 400, maxHeight: 200) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
          fields {
            slug
          }
        }
      }
    }

    courses: allMdx(
      filter: {
        frontmatter: { draft: { ne: true } }
        fileAbsolutePath: { glob: "**/courses/*/index.mdx" }
      }
      sort: { fields: [frontmatter___date], order: DESC }
      limit: 6
    ) {
      edges {
        node {
          id
          excerpt
          frontmatter {
            title
            description
            tags
            subscriberOnly
            date
            source
            featuredImage {
              childImageSharp {
                fluid(maxWidth: 400, maxHeight: 200) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
          fields {
            slug
          }
        }
      }
    }
  }
`;

export default index;
